import React from 'react';
import styled from 'styled-components';
import { Description, ImageContainer, StatsContainer, StyledImage, TenantCardContainer, TenantDetails, TenantSubTitle, TenantTitle } from './styles';
const CardHeader = styled.div `
    display: flex;
`;
const TitleContainer = styled.div `
    display: flex;
    flex-direction: column;
`;
export const TenantMarketplaceCard = ({ catalogImgSrc, title, subTitle, description, stats }) => {
    return (React.createElement(TenantCardContainer, null,
        React.createElement(CardHeader, null,
            React.createElement(ImageContainer, null,
                React.createElement(StyledImage, { imageSrc: catalogImgSrc })),
            React.createElement(TitleContainer, null,
                React.createElement(TenantTitle, null, title),
                React.createElement(TenantSubTitle, null, subTitle))),
        React.createElement(TenantDetails, null,
            React.createElement(Description, null, description),
            React.createElement(StatsContainer, null, stats))));
};
//# sourceMappingURL=TenantMarketplaceCard.js.map